import classNames from 'classnames'
import CheckCircleIcon from 'mdi-react/CheckCircleIcon'
import CloseIcon from 'mdi-react/CloseIcon'
import ErrorIcon from 'mdi-react/ErrorIcon'
import InformationIcon from 'mdi-react/InformationIcon'
import WarningIcon from 'mdi-react/WarningIcon'
import React from 'react'

import { IconButton, Snackbar, SnackbarContent, Theme, Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

const FlashNotice: React.SFC<FlashNoticeProps> = ({
  classes,
  open = true,
  message,
  variant = FlashNoticeVariant.info,
  autoHide = false,
  onBeginClose = () => undefined,
  onEndClose = () => undefined,
}) => {
  const Icon = variantIcon[variant]
  if (!message) {
    return null
  }
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHide ? 5000 : undefined}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={(event, reason) => {
        if (reason !== 'clickaway') {
          onBeginClose()
        }
      }}
      TransitionProps={{
        onExited: onEndClose,
      }}
    >
      <SnackbarContent
        className={classes[variant]}
        aria-describedby="message-id"
        message={
          <span id="message-id" className={classes.messageContainer}>
            <Icon className={classNames(classes.icon, classes.messageIcon)} />
            <Typography variant="body2" className={classes.message}>
              {message}
            </Typography>
          </span>
        }
        action={
          <IconButton key="close" aria-label="Close" color="inherit" onClick={onBeginClose}>
            <CloseIcon className={classes.icon} />
          </IconButton>
        }
      />
    </Snackbar>
  )
}

type FlashNoticeProps = {
  open?: boolean
  message?: string
  variant?: FlashNoticeVariant
  autoHide?: boolean
  onBeginClose: () => any
  onEndClose: () => any
} & WithStyles<typeof styles>

export enum FlashNoticeVariant {
  success = 'success',
  warning = 'warning',
  error = 'error',
  info = 'info',
}

const variantIcon = {
  [FlashNoticeVariant.success]: CheckCircleIcon,
  [FlashNoticeVariant.warning]: WarningIcon,
  [FlashNoticeVariant.error]: ErrorIcon,
  [FlashNoticeVariant.info]: InformationIcon,
}

const styles = ({ palette, spacing }: Theme) => ({
  [FlashNoticeVariant.success]: {
    backgroundColor: palette.extra.positive,
  },
  [FlashNoticeVariant.warning]: {
    backgroundColor: palette.warning.main,
  },
  [FlashNoticeVariant.error]: {
    backgroundColor: palette.error.dark,
  },
  messageContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  messageIcon: {
    opacity: 0.9,
    marginRight: spacing(),
  },
  message: {
    color: palette.common.white,
  },
  icon: {
    fontSize: 16,
    fill: palette.common.white,
  },
})

export default withStyles(styles)(FlashNotice)
